import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { PolicyStatus } from './policyStatus';
import { PolicyField } from '../../../shared/policyField';
import { formatAddress } from 'utils';
import type { FullPolicyData } from 'interfaces/customerDataTypes';

import './policy.scss';

interface PolicyProps {
  selectedPolicy: FullPolicyData;
  isMultiplePolicies: boolean;
  onClickSelect: (arg: boolean) => void;
}
export const Policy = ({ selectedPolicy, isMultiplePolicies, onClickSelect }: PolicyProps): JSX.Element => {
  const { atlasLifecycleStatus, policyEndDate, customerRenewalOptOut, policyNumber, policyDaysUntilRenewal } =
    selectedPolicy;
  return (
    <Row className="policy-row">
      <Col className="policy-column" xs={12} sm={6} lg={6}>
        <h2>HOME INSURANCE</h2>
        <p>View your documents, make policy changes, or check your cover and submit a claim.</p>
        <PolicyField
          label="Address insured"
          value={<p>{formatAddress(selectedPolicy.riskAddress, selectedPolicy.riskPostcode)}</p>}
        />
        <PolicyField label="Policy reference" value={<p id="policy-reference-text">{selectedPolicy.policyNumber}</p>} />
        {isMultiplePolicies && (
          <Link to={`/dashboard/policy/${selectedPolicy.policyNumber}`} onClick={() => onClickSelect(true)}>
            <SvgIcon type={'document' as HpSvgIconTypes} size="very-tiny" className="policy-icon" />
            <p className="policy-text" id="open-policy-modal">
              View another policy
            </p>
          </Link>
        )}
      </Col>
      <Col className="policy-column" xs={12} sm={5} lg={5}>
        <PolicyStatus
          policyStatus={atlasLifecycleStatus}
          endDate={policyEndDate}
          stopRenewal={customerRenewalOptOut}
          policyRef={policyNumber}
          daysUntilRenewal={policyDaysUntilRenewal}
        />
      </Col>
    </Row>
  );
};
